/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-edit-filter': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.25 3.75H2.5v1.981l4.631 4.638.369.362v5.519H10V15h1.25v1.25c0 .69-.56 1.25-1.25 1.25H7.5c-.69 0-1.25-.56-1.25-1.25v-5L1.619 6.619a1.25 1.25 0 01-.369-.888V3.75c0-.69.56-1.25 1.25-1.25h13.75v1.25zm2.319 3.306l-1.875-1.875a.625.625 0 00-.888 0L10 10.994v2.756h2.756l5.813-5.806a.625.625 0 000-.888zM12.244 12.5h-.994v-.994l3.125-3.125.994.994-3.125 3.125zm4.006-4.006l-.994-.994.994-.994.994.994-.994.994z"/>'
  }
})
